export default "__VITE_ASSET__RJSFk7$a__"